<template>
  <section class="pattn">
    <div class="pattn__head"><h2 class="pattn__title">Tus propiedades muy buscadas</h2></div>

    <div v-if="items && items.length" class="pattn__list">
      <button
        v-for="row in items"
        :key="row.property.id"
        type="button"
        class="pattn__row"
        @click="$emit('open-inquiries', row.property)"
      >
        <span class="pattn__main">
          <span class="pattn__type">{{ typeLabel(row.property) }}</span>
          <span class="pattn__addr">{{ row.property.fullAddress }}</span>
        </span>
        <span class="pattn__signals">
          <span class="pattn__sig"><b>{{ row.recentVisits }}</b><small>vieron 24h</small></span>
          <span class="pattn__sig pattn__sig--inq"><b>{{ row.openInquiries }}</b><small>consultas</small></span>
        </span>
        <span class="pattn__actions">
          <span class="pattn__btn">Ver consultas</span>
          <span class="pattn__btn pattn__btn--ghost" role="button" @click.stop="$emit('open-property', row.property)">Propiedad</span>
        </span>
      </button>
    </div>

    <div v-else class="pattn__empty">Ninguna de tus propiedades está en demanda alta ahora.</div>
  </section>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] }
  },
  methods: {
    typeLabel(property) {
      if (!property || !property.propertyType) return "Propiedad";
      return this.$t("property.type." + property.propertyType.toLowerCase());
    }
  }
};
</script>

<style scoped>
.pattn { margin-bottom: 22px; }
.pattn__head { margin-bottom: 10px; }
.pattn__title { font-size: 16px; font-weight: 700; color: #1a1814; margin: 0; }
.pattn__list { display: flex; flex-direction: column; gap: 8px; }
.pattn__row {
  display: flex; align-items: center; gap: 14px; width: 100%; text-align: left;
  background: #fff; border: 1px solid #ece7de; border-radius: 12px; padding: 13px 15px;
  cursor: pointer; font: inherit; color: inherit;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}
.pattn__row:hover { border-color: #dcd4c6; box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18); transform: translateY(-1px); }
.pattn__main { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.pattn__type { font-size: 14px; font-weight: 600; color: #1a1814; }
.pattn__addr { font-size: 12.5px; color: #756f64; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pattn__signals { flex: none; display: flex; gap: 16px; }
.pattn__sig { display: flex; flex-direction: column; align-items: center; min-width: 48px; }
.pattn__sig b { font-size: 16px; font-weight: 700; color: #1a1814; line-height: 1; }
.pattn__sig small { font-size: 10px; color: #a39a8c; margin-top: 3px; }
.pattn__sig--inq b { color: #2c6e49; }
.pattn__actions { flex: none; display: flex; align-items: center; gap: 8px; }
.pattn__btn {
  display: inline-flex; align-items: center; padding: 7px 13px; border-radius: 8px;
  font-size: 12.5px; font-weight: 600; white-space: nowrap; border: 1px solid #b52118; color: #fff; background: #b52118;
}
.pattn__btn--ghost { background: #fff; color: #56504a; border-color: #e3ddd2; }
.pattn__row:hover .pattn__btn:not(.pattn__btn--ghost) { background: #9d1d15; }
.pattn__empty { border: 1px dashed #dcd4c6; border-radius: 12px; padding: 24px; text-align: center; color: #a39a8c; font-size: 13.5px; }
@media (max-width: 600px) { .pattn__actions { display: none; } }
</style>
